import React from 'react';
import Panels from '../Panels';
import BillingOptions from '../BillingOptions';
import DiagnosisCodes from '../DiagnosisCodes';
import SampleCollectionInfo from '../SampleCollectionInfo';

/**
 * Determines which requisition step to display and returns the appropriate component.
 *
 * The 'workflowStepKey' value is stripped out of the incoming props. All other props are passed to the components.
 * These props contain the things needed to display a step (like gearOrder, userInfo, etc.). Order.js render method is
 * a good place to see which props are expected.
 *
 * @param props Props to pass to the requisition step components
 * @param props.workflowStepKey The workflowMetaData key of the step to display ('panel', 'billing', 'diagnosis', 'collection')
 */
const RequisitionWorkflowStep = (props) => {
	const { workflowStepKey, ...commonWorkflowProps } = props;
	if (!workflowStepKey) {
		return null;
	}

	const { gearOrder, userInfo } = commonWorkflowProps;

	let requisitionComponent;
	switch (workflowStepKey) {
		case 'panel':
			let orderType = 'dropShip';
			if (gearOrder?.containsShipToOfficeRequisition) {
				orderType = 'bulk';
			}
			requisitionComponent = <Panels {...commonWorkflowProps} inlineOrderType={orderType} />;
			break;
		case 'billing':
			// Don't get prices for prc users when practitioner has "Do Not Quote Prices to Patients" attribute.
			const doNotQuotePrices = userInfo?.type === 'prc' && gearOrder?.practitioner?.doNotQuotePrices;

			requisitionComponent = <BillingOptions {...commonWorkflowProps} doNotQuotePrices={doNotQuotePrices} />;
			break;
		case 'diagnosis':
			requisitionComponent = <DiagnosisCodes {...commonWorkflowProps} />;
			break;
		case 'collection':
			requisitionComponent = <SampleCollectionInfo {...commonWorkflowProps} inlineMode={true} />;
			break;
		default:
			// No matching step
			break;
	}

	return requisitionComponent;
};

export default RequisitionWorkflowStep;
